import { render, staticRenderFns } from "./DormRoomEditView.vue?vue&type=template&id=2db26770&scoped=true&"
import script from "./DormRoomEditView.vue?vue&type=script&lang=js&"
export * from "./DormRoomEditView.vue?vue&type=script&lang=js&"
import style0 from "./DormRoomEditView.vue?vue&type=style&index=0&id=2db26770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db26770",
  null
  
)

export default component.exports